export default __webpack_public_path__ + "static/media/element_87.2ab3170c.jpg";